import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { GridConfig } from '@inavista/components/grid';
import { centreStatusColumns } from 'projects/service/src/app/shared/utils/grid-status-align';

// Links tab (Service Order, ISC, return order, shipment order, parts order, cart checkout and ISC claims popups) on
// @inavista/components. Same columns, labels, order, default visibility, widths, date format, status pill and
// Order ID / Customer links as the Syncfusion grid it replaces. Rows are the popup's own `links`
// (GET Links/getLinkedRecords, unchanged), served by LocalRowsGridApi. No paging (Martin): the grid scrolls.

export const LINKS_TAB_PERSISTENCE_KEY = 'rims.service.links-tab';

// The rows' fields (LinksViewModel). LN Order ID reads orderIdLN, the field the API sends (fixed, Martin 2026-10-28: the old column read orderIdLN, always blank).
export const LINKS_COLUMNS: [string, string][] = [
  ['srNo', 'int'],
  ['orderId', 'nvarchar'],
  ['customer', 'nvarchar'],
  ['orderIdLN', 'nvarchar'],
  ['orderType', 'nvarchar'],
  ['origin', 'nvarchar'],
  ['quantity', 'int'],
  ['status', 'nvarchar'],
  ['createdDate', 'datetime'],
  ['lastUpdatedDate', 'datetime'],
  ['estimatedArrival', 'datetime'],
];

const ORDER = LINKS_COLUMNS.map(([c]) => c);
const DATE_FORMAT = 'd MMM, yyyy h:mm a';

export function buildLinksTabGridConfig(canExport: boolean, statusColor: (value: unknown) => string): GridConfig {
  return centreStatusColumns({
    apiBaseUrl: 'page://links',
    clientSide: true,
    // The API numbers the rows 1..n (srNo).
    keyColumn: 'srNo',
    rowHeight: 30,
    defaultColumnOrder: ORDER,
    startHiddenColumns: ['lastUpdatedDate', 'estimatedArrival'],
    columnLabels: {
      srNo: 'Sr No.', orderId: 'Order ID', customer: 'Customer', orderIdLN: 'LN Order ID', orderType: 'Order Type',
      origin: 'Order Origin', quantity: 'Quantity', status: 'Status', createdDate: 'Order Date',
      lastUpdatedDate: 'Last Updated Date', estimatedArrival: 'Estimated Arrival',
    },
    // Every column left, as the old grid (Martin: same look as before).
    columnAlign: Object.fromEntries(ORDER.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // The old widths; Status had none and took the space left, so it is the only one that stretches.
    columnWidths: {
      srNo: 120, orderId: 128, customer: 160, orderIdLN: 128, orderType: 160, origin: 160, quantity: 128,
      status: 150, createdDate: 250, lastUpdatedDate: 250, estimatedArrival: 250,
    },
    stretchColumns: true,
    columnSizing: Object.fromEntries(ORDER.filter(c => c !== 'status').map(c => [c, { noStretch: true }])),
    columnTypes: { createdDate: 'datetime', lastUpdatedDate: 'datetime', estimatedArrival: 'datetime' },
    columnDateFormats: { createdDate: DATE_FORMAT, lastUpdatedDate: DATE_FORMAT, estimatedArrival: DATE_FORMAT },
    hyperlinkColumns: ['orderId', 'customer'],
    excelFilterColumns: ['customer', 'orderType', 'origin', 'quantity', 'status'],
    columnColors: { status: statusColor },
    // The old toolbar: Columns, Search, Excel export (AllGrid_Toolbar_Excel_Export only), Clear filters.
    enableExport: canExport,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableResetLayout: true,
    enableRefresh: false,
    enableFooter: false,
    emptyStateMessage: 'No linked records.',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: LINKS_TAB_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  });
}
